import React, { useState, useEffect } from "react";
import { useContent } from "../ContentContext";


const NavBar = () => {
  const content = useContent();
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header
      className={`fixed w-full z-10 py-2 md:py-4 px-4 md:px-8 flex justify-between items-center transition-all duration-300 ${
        isScrolled
          ? "bg-light text-dark bg-opacity-100 shadow-lg"
          : "bg-light bg-opacity-0 text-light"
      }`}
    >
      {/* Logo */}
      <div>
        <a href="/">
          <img
            src="/images/logo.png"
            alt="Logo"
            className="h-12 md:h-20" /* Smaller logo on mobile */
          />
        </a>
      </div>

      {/* Navigation Links */}
      <nav className="flex space-x-4 md:space-x-6">
        <a
          href="products"
          className={`uppercase text-sm md:text-sm lg:text-base font-garet ${
            isScrolled ? "text-dark hover:text-secondary" : "text-light"
          }`}
        >
          {content.header.nav.products}
        </a>
        <a
          href="team"
          className={`uppercase text-sm md:text-sm lg:text-base font-garet ${
            isScrolled ? "text-dark hover:text-secondary" : "text-light"
          }`}
        >
          {content.header.nav.team}
        </a>
        <a
          href="contact"
          className={`uppercase text-sm md:text-sm lg:text-base font-garet ${
            isScrolled ? "text-dark hover:text-secondary" : "text-light"
          }`}
        >
          {content.header.nav.contact}
        </a>
      </nav>
    </header>
  );
};

export default NavBar;
